export default __webpack_public_path__ + "static/media/coffee-cup.1e1280b9.svg";